import user from "./user"

/**
 * Мрашруты приложения
 * @param {Object} context
 * @return {Object}
 */
export default context => {
	return {
		modules: {
			User: user.call(null, context)
		}
	}
}
